import { ReactElement } from "react";
import { Container, } from '@mui/material';

// components
import SoroeruCard from "./components/SoroeruCard";
import InfoCard from "./components/InfoCard";
//  import CompanyPolicyCard from "./components/PolicyCard";


const CompanyPage = (): ReactElement => {

  return (
    <Container sx={{ my: 1, pt: 7, maxWidth: "760px !important" }}>
      <InfoCard />
      <SoroeruCard />
      {/* <CompanyPolicyCard /> */}
    </Container>
  );
};

export default CompanyPage;
